import Component from 'gia/Component'

import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

// import { InertiaPlugin } from "gsap/InertiaPlugin.js";
// gsap.registerPlugin(InertiaPlugin)



class Animation extends Component {

  constructor(element) {

    super(element)

   
    this.element = element
    this.current = 0
    this.index = 0


    this.ref = {
      img: [],
      box: "",
      blast:  "",
      menu: ""
    }

  }

  mount() {

     this.bindedshow = this.show.bind(this)

     gsap.set(this.bindedshow, {
       onRepeat: this.bindedshow,
       repeat: -1,
       repeatDelay: .2
     });

     let spinAnimation = gsap.to(this.ref.box, {rotateY: 360,  duration: 3, ease: 'linear', 
     onComplete: ()=>{
        this.element.classList.add('done')
        spinAnimation.kill()
        this.ref.box.style = ""
     }
     })


      gsap.to(this.ref.blast, {
        opacity: 0,
        scrollTrigger: {
          trigger: this.element,
          start: 'top top',
          end: "top top-=25%",
          scrub: true,
          invalidateOnRefresh: true // to make it responsive
        }

      })


      gsap.fromTo(this.ref.menu, 
        {
          opacity: 0
        },
        
        {
        opacity: 1,
        scrollTrigger: {
          trigger: this.element,
          start: 'top top-=20%',
          end: "top top-=80%",
          scrub: true,
          invalidateOnRefresh: true // to make it responsive
        }

      })


      ScrollTrigger.create({
        trigger: this.element,
        start: "bottom bottom",
       
        onEnter: (self) => {
          spinAnimation.kill()
          this.ref.box.style = ""
          this.element.classList.remove('done')
          this.element.classList.add('spin')
        },
        once: true

        
      });


}

show() {



 this.ref.img[this.current].classList.remove('is-active')
 this.current = gsap.utils.wrap(0, this.ref.img.length, ++this.index)
 this.ref.img[this.current].classList.add('is-active')

}



  unmount() {




  }


}

module.exports = Animation
